import { MonthDayType } from '@g2-shared/api-client/generated/risk-app';

export const PlannedIncreaseMonthDayTypeOptions: Record<MonthDayType, string> = {
  [MonthDayType.FirstDayOfMonth]: 'FirstDayOfMonth',
  [MonthDayType.FirstWorkingDayOfMonth]: 'FirstWorkingDayOfMonth',
  [MonthDayType.LastDayOfMonth]: 'LastDayOfMonth',
  [MonthDayType.LastWorkingDayOfMonth]: 'LastWorkingDayOfMonth',
  [MonthDayType.CertainDayOfMonth]: 'CertainDayOfMonth',
  [MonthDayType.DayInFirstWeekOfMonth]: 'DayInFirstWeekOfMonth',
  [MonthDayType.DayInSecondWeekOfMonth]: 'DayInSecondWeekOfMonth',
  [MonthDayType.DayInThirdWeekOfMonth]: 'DayInThirdWeekOfMonth',
  [MonthDayType.DayInFourthWeekOfMonth]: 'DayInFourthWeekOfMonth',
  [MonthDayType.DayInFifthWeekOfMonth]: 'DayInFifthWeekOfMonth',
};

export const PlannedIncreaseMonthDayTypesWhichRequireDayInput = [
  MonthDayType.CertainDayOfMonth,
  MonthDayType.DayInFirstWeekOfMonth,
  MonthDayType.DayInSecondWeekOfMonth,
  MonthDayType.DayInThirdWeekOfMonth,
  MonthDayType.DayInFourthWeekOfMonth,
  MonthDayType.DayInFifthWeekOfMonth,
];

export const PlannedIncreaseMonthDayTypeLabels: Record<MonthDayType, string> = {
  [MonthDayType.FirstDayOfMonth]: 'FirstDayOfMonth_label',
  [MonthDayType.FirstWorkingDayOfMonth]: 'FirstWorkingDayOfMonth_label',
  [MonthDayType.LastDayOfMonth]: 'LastDayOfMonth_label',
  [MonthDayType.LastWorkingDayOfMonth]: 'LastWorkingDayOfMonth_label',
  [MonthDayType.CertainDayOfMonth]: 'CertainDayOfMonth_label',
  [MonthDayType.DayInFirstWeekOfMonth]: 'DayInFirstWeekOfMonth_label',
  [MonthDayType.DayInSecondWeekOfMonth]: 'DayInSecondWeekOfMonth_label',
  [MonthDayType.DayInThirdWeekOfMonth]: 'DayInThirdWeekOfMonth_label',
  [MonthDayType.DayInFourthWeekOfMonth]: 'DayInFourthWeekOfMonth_label',
  [MonthDayType.DayInFifthWeekOfMonth]: 'DayInFifthWeekOfMonth_label',
};
